/**
 * Splits a house number string by the first '/' into a house number and an orientation number.
 *
 * @example
 * splitHouseNumber('12/3a') // { houseNumber: '12', orientationNumber: '3a', hasSlash: true }
 * splitHouseNumber('12')    // { houseNumber: '12', orientationNumber: '', hasSlash: false }
 */
export const getHouseNumber = (value: string) => {
  const slashIndex = value.indexOf('/');
  if (slashIndex === -1) {
    return { houseNumber: value, orientationNumber: '', hasSlash: false };
  }
  return {
    houseNumber: value.slice(0, slashIndex).trim(),
    orientationNumber: value.slice(slashIndex + 1).trim(),
    hasSlash: true,
  };
};

export const joinHouseNumber = (
  houseNumberRaw?: string | null,
  orientationNumber?: string | null,
) => {
  const houseNumber = houseNumberRaw || '';
  return orientationNumber ? `${houseNumber}/${orientationNumber}` : houseNumber;
};

export const parseHouseNumbers = (
  houseNumberRaw?: string | null,
  orientationNumberRaw?: string | null,
  isOrientationNumberEnabled?: boolean,
) => {
  const houseNumber = houseNumberRaw || '';
  const orientationNumber = orientationNumberRaw || '';

  if (!isOrientationNumberEnabled) {
    return { houseNumber: joinHouseNumber(houseNumber, orientationNumber), orientationNumber: '' };
  }
  return getHouseNumber(joinHouseNumber(houseNumber, orientationNumber));
};

export const resolveHouseNumbers = (
  houseNumberRaw?: string | null,
  orientationNumberRaw?: string | null,
  isOrientationNumberEnabled?: boolean,
) => {
  const houseNumber = houseNumberRaw || '';
  const orientationNumber = orientationNumberRaw || '';

  if (isOrientationNumberEnabled) {
    return {
      houseNumber,
      houseOrientationNumber: orientationNumberRaw ?? undefined,
    };
  }

  return {
    houseNumber: joinHouseNumber(houseNumber, orientationNumber),
    houseOrientationNumber: undefined,
  };
};
